let appxScriptLoaded = false;
let appxScriptElement = null;
let appxScriptPromise = null;
let refCount = 0; // Track how many components are using the script


export default {
	loadAppxScript(scriptSrc) {
		refCount++;

		const appxScriptSrc = scriptSrc;
		// script already loaded, return resolved promise
		if (appxScriptLoaded && appxScriptElement) {
			// console.warn("Script loaded");
			return Promise.resolve({
				scriptLoaded: true,
				element: appxScriptElement,
			});
		}

		// script loading, return existing promise
		if (appxScriptPromise !== null && appxScriptPromise) {
			// console.warn("Script loading...")
			return appxScriptPromise;
		}

		// otherwise, load script
		appxScriptPromise = new Promise((resolve) => {
			// check if script already in DOM
			const existingScript = document.querySelector(
				`script[src="${appxScriptSrc}"]`
			);
			if (existingScript) {
				// console.warn("Script Exists in DOM")
				appxScriptElement = existingScript;
				appxScriptLoaded = true;
				appxScriptPromise = null;

				resolve({
					scriptLoaded: true,
					element: existingScript,
				});
				return;
			}

			// create new script
			const appxElement = document.createElement("script");
			appxElement.src = appxScriptSrc;
			appxElement.async = true;

			appxElement.onload = () => {
				appxScriptLoaded = true;
				appxScriptElement = appxElement;
				appxScriptPromise = null;
				resolve({
					scriptLoaded: true,
					element: appxElement,
				});
			};

			appxElement.onerror = () => {
				appxScriptLoaded = false;
				appxScriptElement = appxElement;
				appxScriptPromise = null;
				resolve({
					scriptLoaded: false,
					element: appxElement,
				});
			};

			// console.warn("Creating appxScript script");
			document.body.appendChild(appxElement);
		});

		return appxScriptPromise;
	},

	removeAppxScript() {
		refCount--;
		if(refCount <= 0){
			if (appxScriptElement && appxScriptElement.parentNode) {
				appxScriptElement.parentNode.removeChild(appxScriptElement);
			}

			appxScriptElement = null;
			appxScriptLoaded = false;
			appxScriptPromise = null;
			refCount = 0;
		}
	},

	miniAppDeposit(mobile, depositAmount, payBillNo, currency) {
		return new Promise(resolve => {
			let depositSuccess = false;

			// console.warn(
			// 	"Payload: ",
			// 	JSON.stringify({
			// 		businessID: payBillNo, // paybill number
			// 		billReference: mobile, //
			// 		amount: depositAmount,
			// 		currency: currency, // currencyCode to be used - only KES supported for now
			// 	}, null, 2)
			// );

			try{
				AlipayJSBridge.call(
					'payBill',
					{
						businessID: payBillNo, // paybill number
						billReference: mobile, //
						amount: depositAmount,
						currency: currency, // currencyCode to be used - only KES supported for now
					},
					(res) => {
						// payment success add logic after success
						// console.warn('successful miniapp deposit', res);
						depositSuccess = true;
						resolve(depositSuccess);
					},
					(err) => {
						// payment failed add logic after failure
						console.error('error occurred during miniapp deposit ', err);
						AlipayJSBridge.call(
							'alert',
							{ title: 'Fail', content: JSON.stringify(err) },
							() => {},
							() => {}
						);
						depositSuccess = false;
						resolve(depositSuccess);
					},
				);

			}catch(error){
				console.error("miniapp catchall ", err);
				AlipayJSBridge.call(
					"alert",
					{ title: "Catch Fail", content: JSON.stringify(error) },
					() => {},
					() => {}
				);

				depositSuccess = false;
				resolve(depositSuccess);
			}
		});

	}
};
